<template>
<div>
  <div
    class="wistia_embed wistia_async_dlhyjs5wsb"
  >
    &nbsp;
  </div>

  <div
    id="congregational_leadersship_choose"
    class="tbk-vid-embed"
  >
    <a
      id="brad_froslee"
      class="embedded_video"
      href="#wistia_k2fhq7ez3j?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="dan_gerrietts"
      class="embedded_video"
      href="#wistia_qs1p07n3sb?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="angela_denker"
      class="embedded_video"
      href="#wistia_keiz0ybocr?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="melissa_pohlman"
      class="embedded_video"
      href="#wistia_slwyf5dtkq?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('dlh', 20, this.showSelect)

    this.tbk.loadCrossTime('k2f', 143, this.showSelect)
    this.tbk.loadCrossTime('qs1', 126, this.showSelect)
    this.tbk.loadCrossTime('kei', 111, this.showSelect)
    this.tbk.loadCrossTime('slw', 155, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        k2f: this.tbk.autoPlay,
        qs1: this.tbk.autoPlay,
        kei: this.tbk.autoPlay,
        slw: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#congregational_leadersship_choose
  display: none
  a
    text-decoration: none
#brad_froslee
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 54%
#dan_gerrietts
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 54%
#angela_denker
  position: absolute
  top: 54%
  left: 0
  width: 50%
  height: 46%
#melissa_pohlman
  position: absolute
  top: 54%
  left: 50%
  width: 50%
  height: 46%
</style>

